<template>
  <isotope :options='getOptions()' :list="renderFiles">
    <div
      v-for="(element, index) in renderFiles"
      :key="`daily-${index}-${element.id}`"
      :class="index % 1 === 0 ? 'row' : ''"
      style="overflow: hidden;width: 100%;"
    >
      <template v-if="allowedExtensions.indexOf(element.ext) !== -1">
        <div class="col-md-12 col-xs-12 col-sm-12">
          <img :src="element.name" class="p-10" style="width: 100%;" />
          <p class="centralizado">{{ element.text }}</p>
        </div>
      </template>
    </div>
  </isotope>
</template>
<script>
import axios from 'axios'

import {
  getFileName,
  checkVariable,
  getParameterOfTheUrl,
} from './../plugins/helper'
import Isotope from './isotope'

export default {
  components: {
    'isotope': Isotope,
  },
  props: {
    reference: {
      type: String,
      default: () => {
        return 'diarios'
      },
    },
  },
  data() {
    return {
      allowedExtensions: ['jpg', 'png', 'jpeg'],
      loading: false,
      files: [],
    }
  },
  computed: {
    renderFiles: function () {
      const tem = []
      if (!this.loading && this.files && this.files.length > 0) {
        const protocol = window.location.protocol
        const host = window.location.host
        let path = null
        this.files.forEach(file => {
          path = `${protocol}//${host}/storage/${file.carpeta}/${file.nombre_generado}`
          tem.push({
            id: file.relacion_id,
            name: path,
            ext: getFileName(path, '.'),
            text: file.descripcion,
          })
        })
      }

      return tem
    },
  },
  mounted: function () {
    this.$nextTick(async function () {
      const search = window.location.search
      let value = null

      if (search && search !== null && search !== '') {
        value = getParameterOfTheUrl(search)
      } else {
        value = this.$route.params
      }

      this.loading = true
      const _this = this
      this.getFile(value)
        .then(data => {
          const { data: daily } = data

          _this.loading = false
          _this.files = daily
        }).catch(error => {
          console.error(error)
          _this.loading = false
        })
    })
  },
  methods:{
    async getFile(params) {
      const currentKey = Object.keys(params).find(key => {
        return checkVariable(params, params[key])
      })
      const value = params[currentKey]

      return axios.get(`/api/files/${value}/${this.reference}`)
    },
    getOptions: function () {
      return {
        layoutMode: 'masonry',
        masonry: {
          gutter: 10,
        },
      }
    },
  },
}
</script>
